'use strict';

import controller from './solicitudesFirma.controller';
import template from './solicitudesFirma.html';

const SolicitudesFirmaSHBComponent = {
  bindings: {},
  controller,
  template
};

export default SolicitudesFirmaSHBComponent;


// WEBPACK FOOTER //
// ./src/app/components/admin/sellobolivia/solicitudesFirma/solicitudesFirma.component.js